import React from 'react';
import PropTypes from 'prop-types';

import '../css/recirc.css';

const RecircLinks = props => (
  <div className="recirc__container">

    <p className="recirc__label benton-bold">Up next</p>

    <div className="recirc__group">
      {Object.keys(props.recirc).map(key => (
        <a href={props.recirc[key].url} className="recirc__link" key={key}>
          <div 
            className="recirc__image" 
            style={{backgroundImage: `url(${props.recirc[key].image})`}}
          >
          </div>
          <h6 className="miller-bold">{props.recirc[key].head}</h6>
        </a>
      ))}
    </div>
  </div>
)

RecircLinks.propTypes = {
  recirc: PropTypes.shape({
    head: PropTypes.string,
    url: PropTypes.string,
    img: PropTypes.string,
  })
}

export default RecircLinks;